import * as t from './submitAQuestionActionTypes';

export const submitNewQuestion = (question) => ({
  type: t.SUBMIT_NEW_QUESTION,
  question,
});

export const setUserCreatedQuestions = (questions) => ({
  type: t.SET_USER_CREATED_QUESTIONS,
  questions,
});

export const setIsUserQuestionsLoading = (isLoading) => ({
  type: t.SET_IS_USER_QUESTIONS_LOADING,
  isLoading,
});

export const setUserQuestionsMessage = (message) => ({
  type: t.SET_USER_QUESTIONS_MESSAGE,
  message,
});

export const getUserSubmittedQuestions = () => ({
  type: t.GET_USER_SUBMITTED_QUESTIONS,
});

export const deleteUserSubmittedQuestion = (questionId, timestamp) => ({
  type: t.DELETE_USER_SUBMITTED_QUESTION,
  questionId,
  timestamp,
});

export const setDeleteStatusMessage = (message) => ({
  type: t.SET_DELETE_STATUS_MESSAGE,
  message,
});

export const editSubmitQuestion = (question, questionId, timestamp) => ({
  type: t.EDIT_SUBMIT_QUESTION,
  question,
  questionId,
  timestamp,
});

export const setSelectedQuestion = (question) => ({
  type: t.SET_SELECTED_QUESTION,
  question,
});
